import * as React from 'react';
import * as moment from 'moment'

export interface IItemProps {
  index: number,
  item: {
    content: string,
    title: string,
    createTime: string
  },
  pc?: boolean
}

export default class Item extends React.Component<IItemProps> {
  
  public openNewsDeatil(detailIndex: number) {
    if (this.props.pc) {
      location.href = '/detail/' + detailIndex
    } else {
      location.href = '/newsDetailHome/' + detailIndex
    }
  }

  public render() {
    return (
      <div onClick={this.openNewsDeatil.bind(this, this.props.index)}>
        <span>{ this.props.item.title }</span>
        <span>{ moment(this.props.item.createTime).format('YYYY-MM-DD') }</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Item/index.tsx